/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Action_Resend_InvitationInputs */

const en_users_action_resend_invitation = /** @type {(inputs: Users_Action_Resend_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend invitation`)
};

const pt_br2_users_action_resend_invitation = /** @type {(inputs: Users_Action_Resend_InvitationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar convite`)
};

/**
* | output |
* | --- |
* | "Resend invitation" |
*
* @param {Users_Action_Resend_InvitationInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_action_resend_invitation = /** @type {((inputs?: Users_Action_Resend_InvitationInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Action_Resend_InvitationInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_action_resend_invitation(inputs)
	return pt_br2_users_action_resend_invitation(inputs)
});